// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__2z40P","content":"ManualTimeModal_content__3Tgai"};